import { Link } from "react-router-dom";
import { useCms } from "@/lib/cms";
import {
  resolveBrandLogoUrl,
  resolveFooterWordmarkUrl,
  BRAND_LOGO_SLOT_CLASS,
} from "@/lib/brandLogo";
import "./SiteBrandRow.css";

const SIZE_CLASS = {
  sm: "site-brand-row--sm",
  md: "site-brand-row--md",
  lg: "site-brand-row--lg",
};

/**
 * User-provided assets only: logo icon PNG + text-only wordmark PNG.
 * No generated/composite images and no extra logo layer.
 */
export default function SiteBrandRow({
  cms: cmsProp,
  size = "sm",
  className = "",
  linkTo,
  linkTestId = "logo-link",
  logoTestId = "logo-image",
  wordmarkTestId = "wordmark-image",
  suffix = null,
  suffixClassName = "text-xs text-white/40 ml-2 border-l border-white/10 pl-3 whitespace-nowrap",
  centered = false,
  iconOnly = false,
}) {
  const { cms: cmsCtx } = useCms();
  const cms = cmsProp ?? cmsCtx;
  const logoUrl = resolveBrandLogoUrl(cms?.media_logo);
  const wordmarkUrl = resolveFooterWordmarkUrl(cms?.media_footer_wordmark);
  const iconClass = BRAND_LOGO_SLOT_CLASS[size] || BRAND_LOGO_SLOT_CLASS.sm;
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.sm;
  const rowClass = `site-brand-row ${sizeClass}${centered ? " site-brand-row--centered" : ""}${iconOnly ? " site-brand-row--icon-only" : ""}${className ? ` ${className}` : ""}`.trim();

  const brand = (
    <>
      <img
        src={logoUrl}
        alt=""
        data-testid={logoTestId}
        className={`site-brand-row__icon ${iconClass} object-contain shrink-0`}
        style={{ background: "transparent" }}
      />
      {!iconOnly ? (
        <img
          src={wordmarkUrl}
          alt=""
          data-testid={wordmarkTestId}
          className="site-brand-row__wordmark"
          style={{ background: "transparent" }}
        />
      ) : null}
    </>
  );

  if (linkTo) {
    return (
      <div className={`site-brand-row-wrap${centered ? " site-brand-row-wrap--centered" : ""}`}>
        <Link to={linkTo} data-testid={linkTestId} className={`${rowClass} group cursor-pointer`}>
          {brand}
        </Link>
        {suffix ? <span className={suffixClassName}>{suffix}</span> : null}
      </div>
    );
  }

  return (
    <div className={`site-brand-row-wrap${centered ? " site-brand-row-wrap--centered" : ""}`}>
      <div className={rowClass}>{brand}</div>
      {suffix ? <span className={suffixClassName}>{suffix}</span> : null}
    </div>
  );
}
